import * as Yup from 'yup'

import { UserRole } from '@shared/utils'

export const getInitialValues = (user) => ({
  isProvider: user.role === UserRole.Provider,

  firstName: user.firstName || '',
  lastName: user.lastName || '',
  phone: user.phone || '',
  email: user.email || '',
  pronouns: user.pronouns || '',
  timezone: user.timezone || '',

  outOfOfficeMessage: user.outOfOfficeMessage || '',

  address: user.homeAddress?.address || '',
  address2: user.homeAddress?.address2 || '',
  city: user.homeAddress?.city || '',
  state: user.homeAddress?.state || '',
  zip: user.homeAddress?.zip || '',
})

export const validationSchema = Yup.object().shape({
  isProvider: Yup.boolean(),

  firstName: Yup.string().trim().required('First Name is required'),
  lastName: Yup.string().trim().required('Last Name is required'),
  phone: Yup.string()
    .trim()
    .min(10, 'Please enter valid phone')
    .max(10, 'Please enter valid phone')
    .when('isProvider', {
      is: true,
      then: Yup.string().trim().required('Phone is required'),
    }),
  email: Yup.string().trim().email('A valid email address is required').max(255).required('Email is required'),
  pronouns: Yup.string().required('Pronouns is required'),
  timezone: Yup.string().required('Timezone is required'),

  outOfOfficeMessage: Yup.string().trim(),

  address: Yup.string().trim(),
  address2: Yup.string().trim(),
  city: Yup.string().trim(),
  state: Yup.string(),
  zip: Yup.string().trim(),
})

export const valuesToApiData = (values, { isAdmin } = {}) => {
  const user = {
    phone: values.phone,
    pronouns: values.pronouns,
    timezone: values.timezone,

    out_of_office_message: values.outOfOfficeMessage?.trim(),
  }

  if (!isAdmin) return { user }

  return {
    user: {
      ...user,
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
    },
    home_address: {
      address: values.address,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zip: values.zip,
    },
  }
}
